<template>
  <div class="container-fluid">
    <slot />
  </div>
</template>